import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputNumber, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component';
import Model from './address-model';  //editable..
import RegionPicklist from '../region/region-picklist.component';

interface IProps { 
    history: History;
    caption?: string;
    parentType?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class AddressCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private historyState: any = this.props.history.location.state;
    
    private onLoadRegion = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'region': data?.id, 'regionCaption': data?.description || ''  }  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    public componentDidMount(): void {    
        this.setState({ datarow: { ...this.state.datarow, [this.props.parentType || 'personalinfo']: this.historyState?.id}  });
    }

    render() {
        return (
            //editable..     
            <>
            <BaseCreate history={this.props.history} caption={this.props.caption}
                model={Model} datarow={this.state.datarow} onError={this.onError}>               
          
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} error={this.state.errors?.type} onChange={this.onChange} />
                {this.state.datarow.type.startsWith('address-') &&
                <>
                <InputMultiline name='street' label='Street, RT, RW, No.' value={this.state.datarow.street} onChange={this.onChange} />
                <InputPicklist name='region' label='Kel/Desa, Kec, Kota, Provinsi' value={this.state.datarow.region} caption={this.state.datarow.regionCaption} onChange={this.onChange} >
                    <RegionPicklist history={this.props.history} currentId={this.state.datarow.region} regionType='village' onLoad={this.onLoadRegion}/>
                </InputPicklist>
                </>
                }
                <Input name='link' label='Link' value={this.state.datarow.link} onChange={this.onChange} />
                <InputNumber name='seq' label='Sequence' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                       
            </BaseCreate>
            </>
        );
    }     
     
}